import React, { useState, useEffect, useRef } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useSelector } from "react-redux";
import writers from "../constants/writers";
import emailjs from "emailjs-com";

const Payment3 = () => {
  const [price, setPrice] = useState(10);
  const paypalConfig = {
    currency: "USD",
    clientId:
      "AbLz9IBwTLz1TBhldyMUVl8bSP5zE9J0pjAiHp-GCeL17rlEIvaRPfkVLlVWp6paGuhWMmPgkZnNNwvU",
  };
  const essayDetails = useSelector((state) => state.order.essayDetails);
  const selectedWriter = useSelector((state) => state.order.selectedWriter);
  const [pickedWirter, setPickedWriter] = useState(null);

  const handleSubmit = async () => {
    try {
      await emailjs.send(
        "service_jmsj315",
        "template_mx0bgns",
        essayDetails,
        "otLa5OVfisTXjCZPZ"
      );

      console.log("Email sent successfully!");
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };
  const shouldSubmit = Object.values(essayDetails).every(
    (value) => value !== ""
  );
  useEffect(() => {
    if (shouldSubmit) {
      handleSubmit();
    }
  }, []);
  const priceRef = useRef(price); // Create a ref to hold the current value of price
  useEffect(() => {
    for (const writer of writers) {
      if (writer.id === selectedWriter) {
        setPickedWriter(writer);
      }
    }
  }, []);

  useEffect(() => {
    // Update the ref value whenever the price state changes
    setPrice(essayDetails.price);
    priceRef.current = price;
  }, [price]);

  const createOrder = (data, actions) => {
    // Use the ref value as the current price in the createOrder function
    const formattedAmount = priceRef.current;
    if (formattedAmount <= 0) {
      console.error("Invalid amount:", formattedAmount);
      return;
    }

    return actions.order.create({
      purchase_units: [
        {
          amount: {
            currency_code: "USD",
            value: formattedAmount,
          },
        },
      ],
    });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      // Handle successful payment here if needed
      console.log(details);
    });
  };

  // Ensure the price state is updated whenever the input changes
  // const handlePriceChange = (e) => {
  //   setPrice(e.target.value);
  // };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center overflow-auto"
      style={{ zIndex: "1" }}
    >
      {/* <div> */}
        <div
          className="rounded-3 mt-2 skyBlueBorder"
          style={{ maxWidth: "550px", width: "95vw" }}
        >
          {/* <h2>Step 3: Payment</h2> */}
          <div className=" fw-bold p-2 text-body-secondary">
            <h3>Order Summary</h3>
            <p>Topic: {essayDetails.topic}</p>
            <p>Subject: {essayDetails.subject}</p>
            <p>Deadline: {essayDetails.deadline}</p>
            <p>Page Count: {essayDetails.pageCount}</p>
            <p>Instructions: {essayDetails.instructions}</p>
            <p>Price: $ {essayDetails.price}</p>
          </div>
          <div className="p-2 fw-bold">
            <h3>Selected Writer</h3>
            <p>Name: {pickedWirter ? pickedWirter.name : ""}</p>
            <p>Rating: {pickedWirter ? pickedWirter.rating : ""}</p>
            {/* Add more writer details as needed */}
          </div>
          {/* Payment methods and checkout button */}
          <div className="mt-3" style={{ zIndex: "1" }}>
            <PayPalScriptProvider options={paypalConfig}>
              <PayPalButtons
                createOrder={(data, actions) => createOrder(data, actions)}
                onApprove={(data, actions) => onApprove(data, actions)}
              />
            </PayPalScriptProvider>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};

export default Payment3;
